import { Dialog } from '@syncfusion/ej2-popups';
import { closest, isNullOrUndefined as isNOU } from '@syncfusion/ej2-base';
import * as events from '../base/constant';
/**
 * Dialog Renderer
 */
export class DialogRenderer {
    constructor(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    addEventListener() {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.on(events.destroy, this.removeEventListener, this);
        this.parent.on(events.documentClickClosedBy, this.documentClickClosedBy, this);
    }
    removeEventListener() {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.off(events.destroy, this.removeEventListener);
        this.parent.off(events.documentClickClosedBy, this.documentClickClosedBy);
    }
    /**
     * dialog render method
     *
     * @param {DialogModel} e - specifies the dialog model.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    render(e) {
        e.beforeOpen = this.beforeOpen.bind(this);
        e.open = this.open.bind(this);
        e.position = {
            X: 'center',
            Y: (e.target !== 'string' && e.target.nodeName === 'BODY' &&
                !isNOU(e.position)) ? e.position.Y : this.getDialogPosition()
        };
        if (isNOU(e.close)) {
            e.close = this.close.bind(this);
        }
        e.beforeClose = this.beforeClose.bind(this);
        if (this.parent.element.dataset.rteUnitTesting === 'true') {
            e.animationSettings = { effect: 'None', duration: 0 };
        }
        const dlgObj = new Dialog(e);
        dlgObj.isStringTemplate = true;
        return dlgObj;
    }
    beforeOpen(args) {
        if (this.parent.quickToolbarModule && this.parent.quickToolbarModule.textQTBar) {
            if (this.parent.quickToolbarModule.textQTBar.element &&
                this.parent.quickToolbarModule.textQTBar.element.classList.contains('e-popup-open') &&
                document.body.contains(this.parent.quickToolbarModule.textQTBar.element)) {
                this.parent.quickToolbarModule.textQTBar.hidePopup();
            }
        }
        if (args.element.classList.contains('e-dialog')) {
            const formEle = closest(args.target, 'form');
            if (!isNOU(formEle)) {
                this.dialogEle = args.element;
                this.dialogEle.addEventListener('keydown', this.handleEnterKeyDown);
            }
        }
        const headerEl = args.element.querySelector('.e-dlg-header');
        if (headerEl) {
            headerEl.setAttribute('title', headerEl.textContent.trim());
        }
        this.parent.trigger(events.beforeDialogOpen, args, this.beforeOpenCallback.bind(this, args));
    }
    handleEnterKeyDown(args) {
        if (args.key === 'Enter') {
            args.stopPropagation();
        }
    }
    beforeOpenCallback(args) {
        if (args.cancel) {
            this.parent.notify(events.clearDialogObj, null);
        }
    }
    open(args) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const isFileMangerDialog = !isNOU(args.container.querySelector('.e-rte-file-manager-dialog'));
        if (isFileMangerDialog) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            args.preventFocus = true;
        }
        this.parent.trigger(events.dialogOpen, args);
    }
    documentClickClosedBy(args) {
        this.outsideClickClosedBy = args.closedBy;
    }
    beforeClose(args) {
        if (this.dialogEle) {
            this.dialogEle.removeEventListener('keydown', this.handleEnterKeyDown);
        }
        args.closedBy = this.outsideClickClosedBy === 'outside click' ? this.outsideClickClosedBy : args.closedBy;
        this.parent.trigger(events.beforeDialogClose, args, (closeArgs) => {
            if (!closeArgs.cancel) {
                if (closeArgs.container.classList.contains('e-popup-close')) {
                    closeArgs.cancel = true;
                }
            }
        });
        this.outsideClickClosedBy = '';
    }
    getDialogPosition() {
        let distanceFromVisibleTop = this.parent.element.getBoundingClientRect().top;
        if (distanceFromVisibleTop < 0) {
            let topHeight = 0;
            let parentElement = this.parent.element;
            while (parentElement.nodeName !== 'BODY') {
                const top = parentElement.getBoundingClientRect().top;
                if (top > 0) {
                    topHeight = top;
                }
                parentElement = parentElement.parentElement;
            }
            distanceFromVisibleTop = Math.abs(distanceFromVisibleTop) + topHeight;
            return distanceFromVisibleTop.toString();
        }
        else {
            return 'top';
        }
    }
    /**
     * dialog close method
     *
     * @param {Object} args - specifies the arguments.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    close(args) {
        this.parent.trigger(events.dialogClose, args);
    }
}
